/**
 * @generated SignedSource<<78102bd1b23ce9bcb0bf4828b62ad668>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavFolderSettingsDropdownFragment$data = {
  readonly id: string;
  readonly product: {
    readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteNavFolderButtonFragment" | "NavFolderSettingsButtonFragment">;
  readonly " $fragmentType": "NavFolderSettingsDropdownFragment";
};
export type NavFolderSettingsDropdownFragment$key = {
  readonly " $data"?: NavFolderSettingsDropdownFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavFolderSettingsDropdownFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavFolderSettingsDropdownFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "usePermissionsFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavFolderSettingsButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteNavFolderButtonFragment"
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};

(node as any).hash = "64f5b57e4acc58d3422efd5a06cc4311";

export default node;
